export class BookingComponentVm {
  SearchKey: string;
  InstanceId: number;
}
